export default __webpack_public_path__ + "static/media/teeth.17dd21c1.svg";